import { Subject } from 'rxjs';

export class VrsChatEventBus {
  static $sendMessage = new Subject<ArrayBufferView>();
  static $receiveMessage = new Subject<string>();
  static $closeDataChannel = new Subject<void>();
  static $clearMessage = new Subject<void>();
  static $sendSignMailMessage = new Subject<string>();
}
